import React from 'react';
import logo from './logo.svg';
import './App.css';
import ZoomComponent from './Zoom';

function App() {
  return <><ZoomComponent /></>
}

export default App;
